export default __webpack_public_path__ + "img/underline.6302bb6d.svg";